// import React, { useEffect, useRef, useState } from 'react';
// import axios from 'axios';
// import { FaBullseye, FaPlus, FaSearch, FaUser, FaVenusMars, FaList, FaMapMarkerAlt, FaCalendarAlt, FaEnvelope, FaPhone, FaTrash, FaTimes } from 'react-icons/fa';
// import { FaEdit } from 'react-icons/fa';
// import * as XLSX from 'xlsx';

// const LeadManagement = () => {

//   const [showForm, setShowForm] = useState(false);
//   const [leads, setLeads] = useState([]);
//   const [editLeadId, setEditLeadId] = useState(null);
//   const [executives, setExecutives] = useState([]);
//   const [assignedExecutive, setAssignedExecutive] = useState("");

//   const [searchTerm, setSearchTerm] = useState("");


//   const [formData, setFormData] = useState({
//     name: '',
//     Comment: '',
//     email: '',
//     contact: '',
//     gender: '',
//     requirement: '',
//     location: '',
//     quantity: "",
//     createdDate: ''
//   });
//   const [isWhatsapp, setIsWhatsapp] = useState(true);
//   const [alternateWhatsapp, setAlternateWhatsapp] = useState('');

//   const [selectedStatus, setSelectedStatus] = useState("LEAD");
//   const statusButtonStyle = (status) => ({ marginRight: '10px', backgroundColor: selectedStatus === status ? '#007bff' : '#f1f1f1', color: selectedStatus === status ? '#fff' : '#000', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '4px' });

//   const [currentPage, setCurrentPage] = useState(1);
//   const leadsPerPage = 10;
//   // const filteredLeads = leads.filter(lead => (lead.status || "LEAD") === selectedStatus);
//   // 🔍 FILTER BY STATUS + SEARCH (Name / Email / Contact)
//   const filteredLeads = leads.filter(lead => {
//     const matchesStatus = (lead.status || "LEAD") === selectedStatus;

//     const search = searchTerm.toLowerCase();
//     const matchesSearch =
//       lead.name?.toLowerCase().includes(search) ||
//       lead.email?.toLowerCase().includes(search) ||
//       lead.contact?.toLowerCase().includes(search);

//     return matchesStatus && matchesSearch;
//   });

//   const indexOfLastLead = currentPage * leadsPerPage;
//   const indexOfFirstLead = indexOfLastLead - leadsPerPage;
//   const currentLeads = filteredLeads.slice(indexOfFirstLead, indexOfLastLead);
//   const totalPages = Math.ceil(filteredLeads.length / leadsPerPage);


//   const user = JSON.parse(sessionStorage.getItem("userData"));
//   console.log(user.id)

//   const showExecutiveSelect =
//     user?.type === "company" ||
//     (user?.type === "employee" && user?.user_type === "Manager");


//   useEffect(() => {
//     if (!showExecutiveSelect) return;

//     const payload =
//       user.type === "company"
//         ? { company_id: user.id }
//         : { manager_id: user.id };

//     fetch("https://cloudapi.emedhatechnologies.com/pages/api/api/get-sales-executives", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     })
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) setExecutives(data.data);
//       });
//   }, [showExecutiveSelect]);


//   // ✅ Fetch leads from backend
//   useEffect(() => {
//     fetchLeads();
//   }, []);

//   // const fetchLeads = async () => {
//   //   try {
//   //     const user = JSON.parse(sessionStorage.getItem("userData"));
//   //     if (!user) {
//   //       console.warn("User data not found in sessionStorage");
//   //       return;
//   //     }

//   //     // ✅ BUILD PARAMS BASED ON ROLE
//   //     const params = {
//   //       // company id always
//   //       user_id: user.type === "company" ? user.id : user.parent_company_id,
//   //     };

//   //     // 🔹 Company
//   //     if (user.type === "company") {
//   //       params.role = "company";
//   //     }

//   //     // 🔹 Manager
//   //     else if (user.type === "employee" && user.user_type === "Manager") {
//   //       params.role = "manager";
//   //       params.employee_id = user.id;
//   //     }

//   //     // 🔹 Executive
//   //     else if (user.type === "employee" && user.user_type === "Executive") {
//   //       params.role = "executive";
//   //       params.employee_id = user.id;
//   //     }

//   //     // ✅ API CALL
//   //     const response = await axios.get(
//   //       'https://cloudapi.emedhatechnologies.com/pages/api/lead-management/by/user',
//   //       { params }
//   //     );

//   //     setLeads(response.data);

//   //   } catch (err) {
//   //     console.error('Error fetching leads:', err);
//   //   }
//   // };

//   const fetchLeads = async () => {
//     try {
//       const user = JSON.parse(sessionStorage.getItem("userData"));
//       if (!user) {
//         console.warn("User data not found in sessionStorage");
//         return;
//       }

//       // ✅ BUILD PARAMS BASED ON ROLE
//       const params = {
//         // company id always
//         user_id: user.type === "company" ? user.id : user.parent_company_id,
//       };

//       // 🔹 Company
//       if (user.type === "company") {
//         params.role = "company";
//       }

//       // 🔹 Manager
//       else if (user.type === "employee" && user.user_type === "Manager") {
//         params.role = "manager";
//         params.employee_id = user.id;
//       }

//       // 🔹 Executive
//       else if (user.type === "employee" && user.user_type === "Executive") {
//         params.role = "executive";
//         params.employee_id = user.id;
//       }

//       // ✅ API CALL
//       const response = await axios.post(
//         'https://cloudapi.emedhatechnologies.com/pages/api/api/new/leads',
//         params
//       );

//       setLeads(response.data);

//     } catch (err) {
//       console.error('Error fetching leads:', err);
//     }
//   };

//   const toggleForm = () => {
//     if (showForm) {
//       resetForm();
//     } else {
//       setFormData(prev => ({
//         ...prev,
//         createdDate: new Date().toISOString().slice(0, 16)
//       }));
//       setShowForm(true);
//     }
//   };

//   const handleInputChange = (e) => {
//     setFormData(prev => ({
//       ...prev,
//       [e.target.name]: e.target.value
//     }));
//   };

//   const validateForm = () => {
//     const errors = [];
//     // Required fields
//     if (!formData.name.trim()) errors.push("Lead Name is required.");
//     // Email
//     if (!formData.email.trim()) {
//       errors.push("Email is required.");
//     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       errors.push("Invalid email format.");
//     }
//     // Contact Number
//     if (!formData.contact.trim()) {
//       errors.push("Contact number is required.");
//     } else if (!/^\d{10,15}$/.test(formData.contact)) {
//       errors.push("Contact number should be 10-15 digits.");
//     }
//     // Gender
//     if (!formData.gender) {
//       errors.push("Gender is required.");
//     }
//     // Requirement
//     if (!formData.requirement.trim()) {
//       errors.push("Requirement is required.");
//     }
//     // Location
//     if (!formData.location.trim()) {
//       errors.push("Location is required.");
//     }
//     // Created Date
//     if (!formData.createdDate.trim()) {
//       errors.push("Created date is required.");
//     } else if (isNaN(Date.parse(formData.createdDate))) {
//       errors.push("Invalid created date.");
//     }
//     return errors;
//   };


//   // ✅ Add new lead
//   const handleSubmitLead = async () => {
//     const errors = validateForm();
//     if (errors.length > 0) {
//       alert(errors.join('\n'));
//       return;
//     }
//     const user = JSON.parse(sessionStorage.getItem("userData"));

//     const companyId = user.type === "company" ? user.id : user.parent_company_id;

//     // ✅ executive assignment logic
//     let executiveId = null;

//     if (user.type === "employee" && user.user_type === "Executive") {
//       executiveId = user.id; // auto assign to self
//     } else {
//       executiveId = assignedExecutive || null; // company / manager selection
//     }


//     const createdByType =
//       user.type === "company"
//         ? "company"
//         : user.user_type === "Manager"
//           ? "manager"
//           : "executive";

//     const dataToSend = {
//       ...formData,
//       user_id: companyId,

//       // ⬇️ NEW FIELDS
//       created_by: user.id,
//       created_by_type: createdByType,
//       updated_by: user.id,
//       executive_id: executiveId,
//       isWhatsapp,
//       alternateWhatsapp: isWhatsapp ? formData.contact : alternateWhatsapp,

//     };
//     try {
//       if (editLeadId) {
//         await axios.put(`https://cloudapi.emedhatechnologies.com/pages/api/lead_management/${editLeadId}`, dataToSend);
//       } else {
//         await axios.post('https://cloudapi.emedhatechnologies.com/pages/api/lead_management', dataToSend);
//       }
//       fetchLeads();
//       resetForm();
//     } catch (err) {
//       console.error('Error saving lead:', err);
//     }
//   };

//   const handleEditLead = (lead) => {
//     setFormData({
//       name: lead.name || '',
//       Comment: lead.Comment || '',
//       email: lead.email || '',
//       contact: lead.contact || '',
//       gender: lead.gender || '',
//       requirement: lead.requirement || '',
//       location: lead.location || '',
//       quantity: lead.quantity || '',

//       createdDate: lead.createdDate ? lead.createdDate.split('T')[0] : ''
//     });

//     setAssignedExecutive(lead.executive_id || '');
//     setEditLeadId(lead.id);
//     setShowForm(true);
//   };
//   const resetForm = () => {
//     setFormData({
//       name: '',
//       Comment: '',
//       email: '',
//       contact: '',
//       gender: '',
//       requirement: '',
//       location: '',
//       quantity: '',
//       createdDate: ''
//     });
//     setEditLeadId(null);
//     setShowForm(false);
//   };




//   const [showStatusModal, setShowStatusModal] = useState(false);
//   const [statusUpdateData, setStatusUpdateData] = useState({
//     id: null,
//     status: '',
//     visitDate: '',
//     statusComment: '',
//     notInterestedReason: '',
//   });

//   const openStatusModal = (id, status) => {
//     setStatusUpdateData({
//       id,
//       status,
//       visitDate: '',
//       statusComment: '',
//       notInterestedReason: '',
//     });
//     setShowStatusModal(true);
//   };

//   const handleSubmitStatusUpdate = async () => {
//     const { id, status, visitDate, statusComment, notInterestedReason } = statusUpdateData;

//     // Basic validation
//     if ((status === 'INTERESTED' || status === 'CALLBACK') && !visitDate) {
//       alert("Visit date is required.");
//       return;
//     }
//     if (status === 'NOT_INTERESTED' && !notInterestedReason) {
//       alert("Please select a reason.");
//       return;
//     }

//     try {
//       const payload = {
//         status,
//         visitDate: visitDate || null,
//         statusComment: statusComment || '',
//         notInterestedReason: status === 'NOT_INTERESTED' ? notInterestedReason : null
//       };

//       await axios.put(`https://cloudapi.emedhatechnologies.com/pages/api/conertedapi/${id}`, payload);

//       fetchLeads();
//       setShowStatusModal(false);
//     } catch (err) {
//       console.error('Error updating status:', err);
//       alert("Failed to update status.");
//     }
//   };








//   // ✅ Delete lead
//   const handleDeleteLead = async (indexToDelete) => {
//     const leadId = leads[indexToDelete].id;
//     try {
//       await axios.delete(`https://cloudapi.emedhatechnologies.com/pages/api/lead_management/${leadId}`);
//       fetchLeads(); // Refresh
//       if ((currentPage - 1) * leadsPerPage >= leads.length - 1 && currentPage > 1) {
//         setCurrentPage(prev => prev - 1);
//       }
//     } catch (err) {
//       console.error('Error deleting lead:', err);
//     }
//   };














//   // handle bulk upload

//   const fileInputRef = useRef(null);
//   const handleUploadClick = () => {
//     fileInputRef.current.click();
//   };




//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const user = JSON.parse(sessionStorage.getItem("userData"));

//     // ✅ company id
//     const companyId =
//       user.type === "company" ? user.id : user.parent_company_id;

//     // ✅ executive assignment
//     let executiveId = null;
//     if (user.type === "employee" && user.user_type === "Executive") {
//       executiveId = user.id;
//     }

//     const createdByType =
//       user.type === "company"
//         ? "company"
//         : user.user_type === "Manager"
//           ? "manager"
//           : "executive";

//     try {
//       const reader = new FileReader();
//       reader.onload = async (event) => {
//         const data = new Uint8Array(event.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const sheetName = workbook.SheetNames[0];
//         const worksheet = workbook.Sheets[sheetName];
//         const jsonData = XLSX.utils.sheet_to_json(worksheet);

//         const parsedData = jsonData.map(row => {
//           if (typeof row.createdDate === 'number') {
//             const excelEpoch = new Date(Date.UTC(1899, 11, 30));
//             const jsDate = new Date(excelEpoch.getTime() + row.createdDate * 24 * 60 * 60 * 1000);
//             row.createdDate = jsDate.toISOString().slice(0, 10);
//           }

//           // Add user_id to each lead
//           return {
//             ...row,
//             user_id: companyId,
//             created_by: user.id,
//             created_by_type: createdByType,
//             updated_by: user.id,

//             // ✅ ONLY FOR EXECUTIVE LOGIN
//             executive_id: executiveId,
//           };
//         });

//         await axios.post('https://cloudapi.emedhatechnologies.com/pages/api/lead_management/bulk', parsedData);

//         alert('Leads uploaded successfully!');
//         fetchLeads();
//       };

//       reader.readAsArrayBuffer(file);
//     } catch (err) {
//       console.error('Error reading Excel file:', err);
//       alert('Invalid Excel file format.');
//     }
//   };



//   const handleDownloadDemoExcel = () => {
//     // Sample data structure (headers should match the expected upload format)
//     const sampleLeads = [
//       {
//         name: "John Doe",
//         Comment: "Interested in product A",
//         email: "john@example.com",
//         contact: "9876543210",
//         gender: "Male",
//         requirement: "Product A",
//         quantity: 20,
//         location: "Mumbai",
//         alternateWhatsapp: "9876543210",
//         createdDate: new Date().toISOString().slice(0, 10), // YYYY-MM-DD
//         isWhatsapp: true
//       },
//       {
//         name: "Jane Smith",
//         Comment: "Requested callback",
//         email: "jane@example.com",
//         contact: "9123456789",
//         gender: "Female",
//         requirement: "Service B",
//         quantity: 40,
//         location: "Delhi",
//         alternateWhatsapp: "9123456789",
//         createdDate: new Date().toISOString().slice(0, 10),
//         isWhatsapp: false
//       }
//     ];

//     // Convert JSON to worksheet
//     const worksheet = XLSX.utils.json_to_sheet(sampleLeads);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "SampleLeads");

//     // Create blob and trigger download
//     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "Lead_Demo_Template.xlsx";
//     link.click();
//     URL.revokeObjectURL(url);
//   };

//   const [categories, setCategories] = useState([]);

//   useEffect(() => {
//     const user = JSON.parse(sessionStorage.getItem("userData"));
//     const userId = user.type === "employee" ? user.parent_company_id : user.id;
//     if (userId) {
//       fetch(`https://cloudapi.emedhatechnologies.com/pages/api/api/products/${userId}`)
//         .then(res => res.json())
//         .then(data => setCategories(data))
//         .catch(err => console.error("Error fetching categories:", err));
//     }
//   }, []);

//   const handleCallClick = (contact) => {
//     window.location.href = `tel:${contact}`;
//   };

//   const maskEmail = (email) => {
//     if (!email) return '';
//     const [user, domain] = email.split('@');
//     if (!domain) return email;
//     // Show first 2 chars of user and full domain, mask the rest of user
//     const visibleUser = user.slice(0, 2);
//     const maskedUser = '*'.repeat(user.length - 2);
//     return `${visibleUser}${maskedUser}@${domain}`;
//   };

//   return (
//     <div style={{ fontFamily: 'Arial, sans-serif', minHeight: '100vh' }}>
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
//         <div>
//           <h2 style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#273179', margin: 0 }}><FaBullseye /> Lead Management</h2>
//           <p style={{ marginTop: '5px', marginLeft: '10px', fontSize: '10px', color: "#273179" }}>Organize leads and track their progress effectively here</p>
//         </div>
//         <div style={{ display: 'flex', gap: '10px' }}>
//           <button onClick={toggleForm} style={{ backgroundColor: showForm ? '#dc3545' : '#3182CE', color: '#fff', padding: '10px 14px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px' }}>
//             {showForm ? '' : <FaPlus />}
//             {showForm ? '' : 'Add Lead'}
//           </button>
//           <button onClick={handleUploadClick} style={{ backgroundColor: '#2076de', color: '#fff', padding: '10px 14px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px' }}><FaPlus /> Bulk Upload Lead</button>
//           <input type="file" accept=".xlsx, .xls" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} />
//           <button onClick={handleDownloadDemoExcel} style={{ backgroundColor: '#2076de', color: '#fff', padding: '10px 14px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px' }}>Excel Demo File</button>
//         </div>
//       </div>


//       {/* 🔍 SEARCH INPUT */}
//       <div style={{ position: 'relative', marginBottom: '15px', width: '100%', maxWidth: '400px', }}>
//         <FaSearch style={{ position: 'absolute', top: '50%', left: '12px', transform: 'translateY(-50%)', color: '#aaa', pointerEvents: 'none', }} />
//         <input type="text" placeholder="Search by Name, Email, Contact..." value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }} style={{ width: '100%', padding: '10px 12px 10px 35px', borderRadius: '8px', border: '1px solid #ddd', background: '#fff', fontSize: '14px', boxSizing: 'border-box', }} />
//       </div>

//       {/* Form */}
//       {/* ⭐ CHANGE START - Add Lead Form Modal ⭐ */}
//       {showForm && (
//         <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.45)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000, }}>
//           <div style={{ background: '#fff', padding: '25px', width: '90%', maxWidth: '750px', borderRadius: '12px', boxShadow: '0 8px 20px rgba(0,0,0,0.25)', animation: 'fadeIn 0.3s ease', }}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <h3 style={{ margin: 0, color: '#333' }}>{editLeadId ? 'Edit Lead' : 'Add New Lead'}</h3>
//               <button onClick={toggleForm} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#777' }} ><FaTimes /></button>
//             </div>
//             <hr style={{ margin: '12px 0' }} />
//             {/* Form inputs */}
//             <div style={{ display: 'grid', gap: '12px', gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'repeat(2, 1fr)', }}>
//               <input name="name" value={formData.name} onChange={handleInputChange} placeholder="Full Name" style={{ padding: '15px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', background: '#fdfdfd', marginTop: '12px' }} />
//               <input name="email" value={formData.email} onChange={handleInputChange} placeholder="Email" style={{ padding: '15px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', background: '#fdfdfd', marginTop: '12px' }} />
//               <input name="contact" value={formData.contact} onChange={handleInputChange} placeholder="Mobile No" style={{ padding: '15px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', background: '#fdfdfd', marginTop: '12px' }} />
//               <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
//                 <label style={{ fontSize: '13px' }}><input type="checkbox" checked={isWhatsapp} onChange={() => setIsWhatsapp(prev => !prev)} />{' '}Is this your WhatsApp?</label>
//               </div>
//               {!isWhatsapp && (<input name="alternateWhatsapp" value={alternateWhatsapp} onChange={(e) => setAlternateWhatsapp(e.target.value)} placeholder="Enter WhatsApp No" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', background: '#fdfdfd', marginTop: '12px' }} />)}
//               <select name="gender" value={formData.gender} onChange={handleInputChange} style={{ marginTop: '12px', padding: '10px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', background: '#fdfdfd' }}>
//                 <option value="">Gender</option>
//                 <option>Male</option>
//                 <option>Female</option>
//                 <option>Other</option>
//               </select>
//               <input name="location" value={formData.location} onChange={handleInputChange} placeholder="Enter Location" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', background: '#fdfdfd', marginTop: '12px' }} />
//               <input name="createdDate" type="datetime-local" value={formData.createdDate} onChange={handleInputChange} style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', background: '#fdfdfd', marginTop: '12px' }} />
//               <select name="requirement" value={formData.requirement} onChange={handleInputChange} style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', background: '#fdfdfd', marginTop: '12px' }}>
//                 <option value="">Select Requirement</option>
//                 {categories.map((category, index) => (
//                   <option key={index} value={category.category}>
//                     {category.category} - {category.subcategory}
//                   </option>
//                 ))}
//               </select>
//               <input name="quantity" value={formData.quantity} onChange={handleInputChange} placeholder="Quantity" style={{ padding: '15px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', background: '#fdfdfd', marginTop: '12px' }} />
//               <input name="Comment" value={formData.Comment} onChange={handleInputChange} placeholder="Comment" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', background: '#fdfdfd', marginTop: '12px' }} />
//               {showExecutiveSelect && (
//                 <select value={assignedExecutive} onChange={(e) => setAssignedExecutive(e.target.value)} style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', background: '#fdfdfd', marginTop: '12px' }}>
//                   <option value="">Assign Sales Executive</option>
//                   {executives.map(exec => (
//                     <option key={exec.id} value={exec.id}>
//                       {exec.name} ({exec.email})
//                     </option>
//                   ))}
//                 </select>
//               )}
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'center' }}>
//               <button onClick={handleSubmitLead} style={{ marginTop: '25px', padding: '10px 16px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', width: '300px', fontSize: '14px', }}>
//                 {editLeadId ? 'Update Lead' : 'Save Lead'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}



//       {/* ⭐ CHANGE END - Add Lead Form Modal ⭐ */}
//       {showStatusModal && (
//         <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
//           <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', minWidth: '300px' }}>
//             <h4>Update Status - {statusUpdateData.status}</h4>
//             {(statusUpdateData.status === 'INTERESTED' || statusUpdateData.status === 'CALLBACK') && (
//               <>
//                 <label>Date of Visit *</label>
//                 <input style={{ width: '90%', padding: '10px', border: '1px solid #ccc', borderRadius: '6px', fontSize: '13px', background: '#fdfdfd', marginTop: '12px', marginBottom: '20px' }} type="datetime-local" value={statusUpdateData.visitDate} onChange={(e) => setStatusUpdateData(prev => ({ ...prev, visitDate: e.target.value }))} />
//                 <label style={{ marginTop: '10px' }}>Comment</label>
//                 <textarea value={statusUpdateData.statusComment} onChange={(e) => setStatusUpdateData(prev => ({ ...prev, statusComment: e.target.value }))} rows={3} style={{ width: '100%', marginBottom: '10px', marginTop: '10px', border: '1px solid #ccc', borderRadius: '6px' }} />
//               </>
//             )}
//             {statusUpdateData.status === 'NOT_INTERESTED' && (
//               <>
//                 <label>Reason for Not Interested *</label>
//                 <select value={statusUpdateData.notInterestedReason} onChange={(e) => setStatusUpdateData(prev => ({ ...prev, notInterestedReason: e.target.value }))} style={{ width: '100%', marginBottom: '10px' }}>
//                   <option value="">Select a reason</option>
//                   <option value="Budget">Budget</option>
//                   <option value="Time">Time</option>
//                   <option value="Location">Location</option>
//                 </select>
//                 <label>Comment</label>
//                 <textarea value={statusUpdateData.statusComment} onChange={(e) => setStatusUpdateData(prev => ({ ...prev, statusComment: e.target.value }))} rows={3} style={{ width: '100%', marginBottom: '10px' }} />
//               </>
//             )}
//             <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
//               <button onClick={handleSubmitStatusUpdate} style={{ background: '#28a745', color: '#fff', padding: '8px 12px', border: 'none', borderRadius: '6px' }}>Submit</button>
//               <button onClick={() => setShowStatusModal(false)} style={{ background: '#dc3545', color: '#fff', padding: '8px 12px', border: 'none', borderRadius: '6px' }}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}


//       <div style={{ background: '#fff', padding: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', marginBottom: '10px', display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'flex-start', }}>
//         <button style={statusButtonStyle("LEAD")} onClick={() => setSelectedStatus("LEAD")}>LEAD</button>
//         <button style={statusButtonStyle("INTERESTED")} onClick={() => setSelectedStatus("INTERESTED")}>INTERESTED</button>
//         <button style={statusButtonStyle("CALLBACK")} onClick={() => setSelectedStatus("CALLBACK")}>CALLBACK</button>
//         <button style={statusButtonStyle("NOT_INTERESTED")} onClick={() => setSelectedStatus("NOT_INTERESTED")}>NOT INTERESTED</button>
//       </div>

//       {/* Table */}
//       <div>
//         <div style={{ overflowX: 'auto', display: window.innerWidth > 768 ? 'block' : 'none' }}>
//           <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', minWidth: '800px' }}>
//             <thead>
//               <tr style={{ background: '#ffffffff' }}>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaUser />Name</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaPhone />Mobile</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaEnvelope />Email</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaVenusMars /> Gender</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaList /> Requirement</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaMapMarkerAlt /> Location</th>

//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaCalendarAlt /> Created Date</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaUser />Comment</th>

//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Actions</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {leads.length === 0 ? (
//                 <tr>
//                   <td colSpan="10" style={{ textAlign: 'center', padding: '20px', color: '#999' }}>No leads found.</td>
//                 </tr>
//               ) : (
//                 currentLeads.map((lead, index) => (
//                   <tr key={lead.id}>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{lead.name}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', }}><FaPhone onClick={() => handleCallClick(lead.contact)} style={{ color: '#007bff' }} title="Call Dealer" /></td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{maskEmail(lead.email)}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{lead.gender}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{lead.requirement}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{lead.location}</td>

//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{lead.createdDate ? new Date(lead.createdDate).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }) : ''}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{lead.Comment}</td>

//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>
//                       <button onClick={() => handleDeleteLead(indexOfFirstLead + index)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#007bff', fontSize: '14px' }}><FaTrash /></button>
//                       <button onClick={() => handleEditLead(lead)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#007bff', fontSize: '14px' }}>  <FaEdit /></button>
//                     </td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444', display: 'flex', gap: '6px' }}>
//                       {lead.status !== 'INTERESTED' && (<button title="Mark as INTERESTED" onClick={() => openStatusModal(lead.id, "INTERESTED")} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#007bff', fontSize: '14px' }}><FaBullseye /></button>)}
//                       {lead.status !== 'CALLBACK' && (<button title="Mark as CALLBACK" onClick={() => openStatusModal(lead.id, "CALLBACK")} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#007bff', fontSize: '14px' }}><FaPhone /></button>)}
//                       {lead.status !== 'NOT_INTERESTED' && (<button title="Mark as NOT INTERESTED" onClick={() => openStatusModal(lead.id, "NOT_INTERESTED")} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#007bff', fontSize: '14px' }}><FaTrash /></button>)}
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         <div style={{ display: window.innerWidth <= 768 ? 'block' : 'none' }}>
//           {currentLeads.map((lead) => (
//             <div key={lead.id} style={{ background: '#fff', padding: '12px', marginBottom: '12px', borderRadius: '8px', boxShadow: '0 2px 6px rgba(0,0,0,0.1)', fontSize: '14px' }}>
//               <div><strong>Name:</strong> {lead.name}</div>
//               <div><strong>Mobile:</strong> <FaPhone onClick={() => handleCallClick(lead.contact)} style={{ color: '#007bff', cursor: 'pointer', marginLeft: '6px' }} /> {lead.contact}</div>
//               <div><strong>Email:</strong> {maskEmail(lead.email)}</div>
//               <div><strong>Gender:</strong> {lead.gender}</div>
//               <div><strong>Requirement:</strong> {lead.requirement}</div>
//               <div><strong>Location:</strong> {lead.location}</div>
//               <div><strong>Created:</strong> {lead.createdDate ? new Date(lead.createdDate).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }) : ''}</div>
//               <div style={{ display: 'flex', gap: '6px', marginTop: '8px' }}>
//                 <button onClick={() => handleEditLead(lead)} style={{ background: '#007bff', color: '#fff', border: 'none', padding: '6px 10px', borderRadius: '4px', cursor: 'pointer' }}>Edit</button>
//                 <button onClick={() => handleDeleteLead(lead.id)} style={{ background: '#dc3545', color: '#fff', border: 'none', padding: '6px 10px', borderRadius: '4px', cursor: 'pointer' }}>Delete</button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Pagination */}
//       <div style={{ textAlign: 'center', marginTop: '15px' }}>
//         <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} style={paginationBtn(currentPage > 1)}>Previous</button>
//         <span style={{ margin: '0 8px', fontSize: '12px', color: '#333' }}>Page {currentPage} of {totalPages || 1}</span>
//         <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages || totalPages === 0} style={paginationBtn(currentPage < totalPages)}>Next</button>
//       </div>

//     </div>

//   );
// };

// // 🎨 Styles

// const paginationBtn = (active) => ({
//   padding: '8px 14px', margin: '0 6px', background: active ? '#fff' : '#e9ecef',
//   border: '1px solid #ccc', borderRadius: '6px',
//   cursor: active ? 'pointer' : 'not-allowed',
//   color: active ? '#007bff' : '#aaa', fontSize: '13px'
// });

// export default LeadManagement;



// import React, { useState } from 'react';
// import {
//   Plus,
//   Search,
//   Phone,
//   Mail,
//   MapPin,
//   MessageSquare,
//   Edit,
//   X,
//   Download,
//   Calendar,
//   ChevronLeft,
//   ChevronRight,
//   ThumbsUp,
//   ThumbsDown,
//   PhoneCall
// } from 'lucide-react';

// const LEADS_PER_PAGE = 8;

// const initialLeads = [
//   { id: 'L-01', name: 'Siva M2', mobile: '06300917165', email: 'tr*@gmail.com', gender: 'Male', requirement: 'Teak - Teak Classic', location: 'Hyderabad', createdDate: '24/12/2025, 11:55 am', comment: 'OK', status: 'INTERESTED', isWhatsApp: true, executive: 'Se1' },
//   { id: 'L-02', name: 'Siva M1', mobile: '06300917145', email: 'tr@gmail.com', gender: 'Male', requirement: 'Specials - D-ART COLLECTIONS - D-12', location: 'Hyderabad', createdDate: '24/12/2025, 11:53 am', comment: 'OK', status: 'LEAD', isWhatsApp: true, executive: 'Se2' },
//   { id: 'L-03', name: 'Siva Siva', mobile: '06300917192', email: 'tr*********@gmail.com', gender: 'Male', requirement: "ECHITED SERIES - Am'White Oak", location: 'Hyderabad', createdDate: '24/12/2025, 11:52 am', comment: 'OK', status: 'CALLBACK', isWhatsApp: true, executive: 'Se1' },
//   { id: 'L-04', name: 'lead3', mobile: '9845011223', email: 'le***@gmail.com', gender: 'Male', requirement: 'somked Series - Smoke Oak', location: '12345', createdDate: '20/12/2025, 12:52 pm', comment: 'ok', status: 'NOT INTERESTED', isWhatsApp: false, executive: 'Se1' },
//   { id: 'L-05', name: 'leadm2', mobile: '9845011224', email: 'le****@gmail.com', gender: 'Male', requirement: 'Specials - D-ART COLLECTIONS - Waltz', location: '12345', createdDate: '20/12/2025, 12:37 pm', comment: 'ok', status: 'LEAD', isWhatsApp: false, executive: 'Se1' },
//   { id: 'L-06', name: 'LeadMM', mobile: '9845011225', email: 'le****@gmail.com', gender: 'Male', requirement: 'ECHITED SERIES - Am Walnut Crown', location: 'Hyderabad', createdDate: '20/12/2025, 12:00 am', comment: 'OK', status: 'INTERESTED', isWhatsApp: true, executive: 'Se2' }
// ];

// const productRequirements = [
//   "Teak - Teak Classic",
//   "Standrad Naturals - Am white oak Qtr’ 10x4",
//   "Standrad Naturals - Am Walnut Crown 10x4",
//   "Standrad Naturals - White Oak Qtr'",
//   "DYED Series - Oak Dyed Frosted",
//   "DYED Series - Sucupira Dyed Grey",
//   "DYED Series - Ash Dyed Velvet Grey",
//   "DYED Series - Bolivaer Dyed Sierra",
//   "DYED Series - Ash Dyed golden Dune",
//   "DYED Series - Oak Dyed Sand",
//   "Standrad Naturals - White Oak Crown",
//   "DYED Series - Olive Ash",
//   "DYED Series - Olive Ash H/Z",
//   "Standrad Naturals - Am Walnut Qtr",
//   "Standrad Naturals - Anegre",
//   "Standrad Naturals - Red Oak Qtr",
//   "Standrad Naturals - Red Oak Crown",
//   "DYED Series - Koto Dyed Blue",
//   "somked Series - Smoke Oak Crown",
//   "DYED Series - Sycamore Dyed Grey",
//   "somked Series - Smoke Oak",
//   "Teak - Teak Essentia",
//   "ECHITED SERIES - Koto dyed Silver Grey",
//   "ECHITED SERIES - Lati Dyed Ash Grey",
//   "ECHITED SERIES - Am'White Oak",
//   "ECHITED SERIES - Am' Walnut Crown",
//   "ECHITED SERIES - Platino Dyed Grey",
//   "ECHITED SERIES - Euclyptus Dyd SI.Grey - Blk Anudeep",
//   "ECHITED SERIES - American White Oak Etched",
//   "Specials - D-ART COLLECTIONS - D-12",
//   "Specials - D-ART COLLECTIONS - D-10"
// ];

// // Inline Styles Object Blueprint
// const styles = {
//   container: { padding: '24px', maxWidth: '1280px', margin: '0 auto', fontFamily: 'system-ui, sans-serif', backgroundColor: '#f9fafb', color: '#111827' },
//   headerSection: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'between', gap: '16px', marginBottom: '24px' },
//   title: { fontSize: '24px', fontWeight: '900', letterSpacing: '-0.5px', margin: '0 0 4px 0' },
//   subtitle: { fontSize: '14px', color: '#6b7280', margin: 0 },
//   btnGroup: { display: 'flex', alignItems: 'center', gap: '8px', marginLeft: 'auto' },
//   btnSec: { display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: '8px', backgroundColor: '#ffffff', color: '#4b5563', fontSize: '12px', fontWeight: '600', cursor: 'pointer' },
//   btnPri: { display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 16px', border: 'none', borderRadius: '8px', backgroundColor: '#2563eb', color: '#ffffff', fontSize: '12px', fontWeight: '700', cursor: 'pointer', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' },
//   filterCard: { backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', marginBottom: '24px', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '16px' },
//   tabWrapper: { display: 'flex', gap: '4px', overflowX: 'auto' },
//   tabBtn: (isActive) => ({ padding: '6px 12px', borderRadius: '8px', fontSize: '12px', fontWeight: '700', border: isActive ? '1px solid rgba(37,99,235,0.2)' : '1px solid transparent', backgroundColor: isActive ? 'rgba(37,99,235,0.1)' : 'transparent', color: isActive ? '#2563eb' : '#6b7280', cursor: 'pointer', whiteSpace: 'nowrap' }),
//   searchWrapper: { position: 'relative', width: '288px' },
//   searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', color: '#9ca3af' },
//   searchInput: { width: '100%', padding: '8px 12px 8px 36px', fontSize: '12px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', outline: 'none', color: '#111827' },
//   tableWrapper: { backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' },
//   table: { width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '12px' },
//   thead: { backgroundColor: '#f3f4f6', color: '#6b7280', textTransform: 'uppercase', fontSize: '10px', letterSpacing: '0.05em', borderBottom: '1px solid #e5e7eb' },
//   th: { padding: '12px 16px', fontWeight: '700' },
//   tr: { borderBottom: '1px solid #e5e7eb' },
//   td: { padding: '14px 16px', verticalAlign: 'top' },
//   profileName: { fontWeight: '700', fontSize: '13px', color: '#111827', display: 'block' },
//   profileMeta: { fontSize: '10px', color: '#6b7280', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', display: 'inline-block', marginTop: '4px' },
//   contactItem: { display: 'flex', alignItems: 'center', gap: '4px', fontFamily: 'monospace', color: '#111827', fontWeight: '600' },
//   badgeWa: { fontSize: '9px', backgroundColor: 'rgba(16,185,129,0.1)', color: '#059669', padding: '1px 4px', borderRadius: '4px', fontFamily: 'sans-serif' },
//   reqText: { fontWeight: '500', color: '#111827', display: 'block' },
//   locWrapper: { display: 'flex', alignItems: 'center', gap: '4px', fontSize: '10px', color: '#6b7280', marginTop: '4px' },
//   logDate: { fontSize: '10px', color: '#6b7280', fontFamily: 'monospace' },
//   logComment: { display: 'flex', alignItems: 'center', gap: '4px', color: '#374151', fontSize: '11px', marginTop: '4px' },
//   badgeStatus: (status) => {
//     let bg = '#eee', text = '#333';
//     if (status === 'LEAD') { bg = '#dbeafe'; text = '#1e40af'; }
//     else if (status === 'INTERESTED') { bg = '#d1fae5'; text = '#065f46'; }
//     else if (status === 'CALLBACK') { bg = '#fef3c7'; text = '#92400e'; }
//     else if (status === 'NOT INTERESTED') { bg = '#ffe4e6'; text = '#9f1239'; }
//     return { padding: '2px 8px', borderRadius: '9999px', fontSize: '10px', fontWeight: '800', textTransform: 'uppercase', display: 'inline-block', backgroundColor: bg, color: text };
//   },
//   actionGroup: { display: 'flex', alignItems: 'center', gap: '6px' },
//   actBtn: (type) => {
//     let bg = '#f3f4f6', border = '#e5e7eb', text = '#4b5563';
//     if (type === 'int') { bg = '#ecfdf5'; border = '#a7f3d0'; text = '#047857'; }
//     else if (type === 'cb') { bg = '#fffbeb'; border = '#fde68a'; text = '#b45309'; }
//     else if (type === 'ni') { bg = '#fff5f5'; border = '#fed7d7'; text = '#c53030'; }
//     return { padding: '6px', borderRadius: '6px', border: `1px solid ${border}`, backgroundColor: bg, color: text, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' };
//   },
//   footer: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', borderTop: '1px solid #e5e7eb', flexWrap: 'wrap', gap: '12px' },
//   pageBtn: (isActive) => ({ width: '32px', height: '32px', borderRadius: '8px', fontSize: '12px', fontWeight: '500', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', border: isActive ? 'none' : '1px solid #e5e7eb', backgroundColor: isActive ? '#2563eb' : '#ffffff', color: isActive ? '#ffffff' : '#6b7280' }),
//   modalOverlay: { position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', backdropFilter: 'blur(4px)' },
//   modalContainer: (maxW = '576px') => ({ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '16px', width: '100%', maxWidth: maxW, boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)', maxHeight: '90vh', overflowY: 'auto' }),
//   modalHeader: { padding: '16px 24px', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
//   formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px' },
//   formGroup: { display: 'flex', flexDirection: 'column', gap: '4px' },
//   label: { fontSize: '12px', fontWeight: '600', color: '#6b7280' },
//   input: { padding: '8px 12px', fontSize: '12px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', outline: 'none', color: '#111827' },
//   select: { padding: '8px 12px', fontSize: '12px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', outline: 'none', color: '#111827' },
//   textarea: { padding: '8px 12px', fontSize: '12px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', outline: 'none', color: '#111827', resize: 'none' }
// };

// const LeadManagement = () => {
//   const [leads, setLeads] = useState(initialLeads);
//   const [activeTab, setActiveTab] = useState('ALL');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingLead, setEditingLead] = useState(null);

//   const [statusAction, setStatusAction] = useState(null);
//   const [actionLead, setActionLead] = useState(null);
//   const [actionDate, setActionDate] = useState('');
//   const [actionComment, setActionComment] = useState('');
//   const [actionReason, setActionReason] = useState('');

//   const NOT_INTERESTED_REASONS = [
//     'Price too high',
//     'Not the right product',
//     'Already purchased elsewhere',
//     'No budget at this time',
//     'Not interested right now',
//     'Other',
//   ];

//   const openStatusAction = (lead, action) => {
//     setActionLead(lead);
//     setStatusAction(action);
//     setActionDate('');
//     setActionComment('');
//     setActionReason('');
//   };

//   const closeStatusAction = () => {
//     setStatusAction(null);
//     setActionLead(null);
//   };

//   const submitStatusAction = (e) => {
//     e.preventDefault();
//     if (!actionLead || !statusAction) return;
//     const newStatus =
//       statusAction === 'INTERESTED' ? 'INTERESTED' :
//       statusAction === 'CALLBACK' ? 'CALLBACK' : 'NOT INTERESTED';
//     setLeads(prev => prev.map(l =>
//       l.id === actionLead.id
//         ? { ...l, status: newStatus, comment: actionComment || l.comment }
//         : l
//     ));
//     closeStatusAction();
//   };

//   const [formData, setFormData] = useState({
//     name: '',
//     mobile: '',
//     email: '',
//     gender: 'Male',
//     requirement: productRequirements[0],
//     location: '',
//     comment: '',
//     status: 'LEAD',
//     isWhatsApp: true,
//     executive: 'Se1'
//   });

//   const resetForm = () => {
//     setFormData({
//       name: '',
//       mobile: '',
//       email: '',
//       gender: 'Male',
//       requirement: productRequirements[0],
//       location: '',
//       comment: '',
//       status: 'LEAD',
//       isWhatsApp: true,
//       executive: 'Se1'
//     });
//     setEditingLead(null);
//   };

//   const handleOpenAddModal = () => {
//     resetForm();
//     setIsModalOpen(true);
//   };

//   const handleOpenEditModal = (lead) => {
//     setEditingLead(lead);
//     setFormData({
//       name: lead.name,
//       mobile: lead.mobile,
//       email: lead.email,
//       gender: lead.gender,
//       requirement: lead.requirement,
//       location: lead.location,
//       comment: lead.comment,
//       status: lead.status,
//       isWhatsApp: lead.isWhatsApp,
//       executive: lead.executive
//     });
//     setIsModalOpen(true);
//   };

//   const handleSaveLead = (e) => {
//     e.preventDefault();
//     const targetDateStr = new Date().toLocaleString('en-GB', { hour12: true }).toLowerCase();

//     if (editingLead) {
//       setLeads(leads.map(l => l.id === editingLead.id ? { ...l, ...formData } : l));
//     } else {
//       const newLead = {
//         id: `L-${Math.floor(Math.random() * 900) + 100}`,
//         ...formData,
//         createdDate: targetDateStr
//       };
//       setLeads([newLead, ...leads]);
//     }
//     setIsModalOpen(false);
//     resetForm();
//   };

//   const filteredLeads = leads.filter(lead => {
//     const matchesTab = activeTab === 'ALL' || lead.status === activeTab;
//     const matchesSearch = lead.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                           lead.mobile.includes(searchTerm) ||
//                           lead.requirement.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                           lead.location.toLowerCase().includes(searchTerm.toLowerCase());
//     return matchesTab && matchesSearch;
//   });

//   const totalPages = Math.max(1, Math.ceil(filteredLeads.length / LEADS_PER_PAGE));
//   const safePage = Math.min(currentPage, totalPages);
//   const pagedLeads = filteredLeads.slice((safePage - 1) * LEADS_PER_PAGE, safePage * LEADS_PER_PAGE);

//   const handleFilterChange = (tab) => { setActiveTab(tab); setCurrentPage(1); };
//   const handleSearch = (val) => { setSearchTerm(val); setCurrentPage(1); };

//   return (
//     <div style={styles.container}>
//       {/* Top Header Section */}
//       <div style={styles.headerSection}>
//         <div>
//           <h1 style={styles.title}>Lead Management</h1>
//           <p style={styles.subtitle}>Organize leads and track their progress effectively here</p>
//         </div>

//         <div style={styles.btnGroup}>
//           <button onClick={() => alert('Downloading Excel template...')} style={styles.btnSec}>
//             <Download style={{ width: '14px', height: '14px' }} />
//             <span>Excel Demo File</span>
//           </button>

//           <button onClick={handleOpenAddModal} style={styles.btnPri}>
//             <Plus style={{ width: '16px', height: '16px' }} />
//             <span>Add Lead</span>
//           </button>
//         </div>
//       </div>

//       {/* Tabs & Search controls container */}
//       <div style={styles.filterCard}>
//         <div style={styles.tabWrapper}>
//           {['ALL', 'LEAD', 'INTERESTED', 'CALLBACK', 'NOT INTERESTED'].map((tab) => (
//             <button
//               key={tab}
//               onClick={() => handleFilterChange(tab)}
//               style={styles.tabBtn(activeTab === tab)}
//             >
//               {tab} ({tab === 'ALL' ? leads.length : leads.filter(l => l.status === tab).length})
//             </button>
//           ))}
//         </div>

//         <div style={styles.searchWrapper}>
//           <Search style={styles.searchIcon} />
//           <input 
//             type="text"
//             placeholder="Search by name, mobile, wood series..."
//             value={searchTerm}
//             onChange={(e) => handleSearch(e.target.value)}
//             style={styles.searchInput}
//           />
//         </div>
//       </div>

//       {/* Leads Table View */}
//       <div style={styles.tableWrapper}>
//         <table style={styles.table}>
//           <thead style={styles.thead}>
//             <tr>
//               <th style={styles.th}>Lead Profile</th>
//               <th style={styles.th}>Contact Info</th>
//               <th style={styles.th}>Requirement Series</th>
//               <th style={styles.th}>Meta Logs</th>
//               <th style={styles.th}>Status</th>
//               <th style={{ ...styles.th, textAlign: 'center' }}>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {pagedLeads.length === 0 ? (
//               <tr>
//                 <td colSpan={6} style={{ ...styles.td, textAlign: 'center', padding: '32px', color: '#6b7280' }}>
//                   No records found matching current selection pipeline filter criteria.
//                 </td>
//               </tr>
//             ) : pagedLeads.map((lead) => (
//               <tr key={lead.id} style={styles.tr}>

//                 {/* Lead Profile */}
//                 <td style={styles.td}>
//                   <span style={styles.profileName}>{lead.name}</span>
//                   <span style={styles.profileMeta}>
//                     {lead.id} ({lead.gender})
//                   </span>
//                 </td>

//                 {/* Contact Info */}
//                 <td style={styles.td}>
//                   <div style={styles.contactItem}>
//                     <Phone style={{ width: '12px', height: '12px', color: '#6b7280' }} />
//                     <span>{lead.mobile}</span>
//                     {lead.isWhatsApp && (
//                       <span style={styles.badgeWa}>WhatsApp</span>
//                     )}
//                   </div>
//                   <div style={{ ...styles.contactItem, fontWeight: '400', color: '#6b7280', marginTop: '4px' }}>
//                     <Mail style={{ width: '12px', height: '12px' }} />
//                     <span style={{ maxWidth: '140px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{lead.email}</span>
//                   </div>
//                 </td>

//                 {/* Wood Requirement Series */}
//                 <td style={styles.td}>
//                   <div style={{ maxWidth: '220px' }}>
//                     <span style={styles.reqText}>{lead.requirement}</span>
//                     <div style={styles.locWrapper}>
//                       <MapPin style={{ width: '12px', height: '12px', color: '#ef4444' }} />
//                       <span>Loc: {lead.location}</span>
//                     </div>
//                   </div>
//                 </td>

//                 {/* History Logs */}
//                 <td style={styles.td}>
//                   <div style={styles.logDate}>
//                     <span>{lead.createdDate}</span>
//                   </div>
//                   <div style={styles.logComment}>
//                     <MessageSquare style={{ width: '12px', height: '12px', color: '#6b7280', flexShrink: 0 }} />
//                     <span style={{ maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={lead.comment}>
//                       {lead.comment || 'No comment added'}
//                     </span>
//                   </div>
//                 </td>

//                 {/* Status Column */}
//                 <td style={styles.td}>
//                   <span style={styles.badgeStatus(lead.status)}>
//                     {lead.status}
//                   </span>
//                 </td>

//                 {/* Status Action Buttons */}
//                 <td style={styles.td}>
//                   <div style={{ ...styles.actionGroup, justifyContent: 'center' }}>
//                     <button title="Mark Interested" onClick={() => openStatusAction(lead, 'INTERESTED')} style={styles.actBtn('int')}>
//                       <ThumbsUp style={{ width: '14px', height: '14px' }} />
//                     </button>
//                     <button title="Schedule Callback" onClick={() => openStatusAction(lead, 'CALLBACK')} style={styles.actBtn('cb')}>
//                       <PhoneCall style={{ width: '14px', height: '14px' }} />
//                     </button>
//                     <button title="Not Interested" onClick={() => openStatusAction(lead, 'NOT_INTERESTED')} style={styles.actBtn('ni')}>
//                       <ThumbsDown style={{ width: '14px', height: '14px' }} />
//                     </button>
//                     <button title="Edit" onClick={() => handleOpenEditModal(lead)} style={styles.actBtn('def')}>
//                       <Edit style={{ width: '14px', height: '14px' }} />
//                     </button>
//                   </div>
//                 </td>

//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {/* Pagination Footer */}
//         {filteredLeads.length > 0 && (
//           <div style={styles.footer}>
//             <p style={{ fontSize: '12px', color: '#6b7280', margin: 0 }}>
//               Showing <span style={{ fontWeight: '600', color: '#111827' }}>{(safePage - 1) * LEADS_PER_PAGE + 1}</span>–<span style={{ fontWeight: '600', color: '#111827' }}>{Math.min(safePage * LEADS_PER_PAGE, filteredLeads.length)}</span> of <span style={{ fontWeight: '600', color: '#111827' }}>{filteredLeads.length}</span> leads
//             </p>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//               <button
//                 onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
//                 disabled={safePage === 1}
//                 style={{ ...styles.pageBtn(false), opacity: safePage === 1 ? 0.4 : 1, cursor: safePage === 1 ? 'not-allowed' : 'pointer' }}
//               >
//                 <ChevronLeft style={{ width: '16px', height: '16px' }} />
//               </button>
//               {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
//                 <button
//                   key={page}
//                   onClick={() => setCurrentPage(page)}
//                   style={styles.pageBtn(page === safePage)}
//                 >
//                   {page}
//                 </button>
//               ))}
//               <button
//                 onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
//                 disabled={safePage === totalPages}
//                 style={{ ...styles.pageBtn(false), opacity: safePage === totalPages ? 0.4 : 1, cursor: safePage === totalPages ? 'not-allowed' : 'pointer' }}
//               >
//                 <ChevronRight style={{ width: '16px', height: '16px' }} />
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Main Structural Add/Edit Modal */}
//       {isModalOpen && (
//         <div style={styles.modalOverlay}>
//           <div style={styles.modalContainer('576px')}>
//             <div style={styles.modalHeader}>
//               <div>
//                 <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '900' }}>{editingLead ? 'Modify Existing Lead Details' : 'Add New Lead Segment'}</h3>
//                 <p style={{ margin: '2px 0 0 0', fontSize: '12px', color: '#6b7280' }}>Input parameters relative to client wood series requirement logs.</p>
//               </div>
//               <button onClick={() => setIsModalOpen(false)} style={{ ...styles.actBtn('def'), padding: '6px' }}>
//                 <X style={{ width: '16px', height: '16px' }} />
//               </button>
//             </div>

//             <form onSubmit={handleSaveLead} style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
//               <div style={styles.formGrid}>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Client Prospect Name *</label>
//                   <input type="text" required value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} placeholder="Enter customer name" style={styles.input} />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Mobile Contact Number *</label>
//                   <input type="tel" required value={formData.mobile} onChange={(e) => setFormData({...formData, mobile: e.target.value})} placeholder="Enter phone number" style={styles.input} />
//                 </div>
//               </div>

//               <div style={styles.formGrid}>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Email Address</label>
//                   <input type="email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} placeholder="client@domain.com" style={styles.input} />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Geographic Location / City</label>
//                   <input type="text" value={formData.location} onChange={(e) => setFormData({...formData, location: e.target.value})} placeholder="e.g. Hyderabad" style={styles.input} />
//                 </div>
//               </div>

//               <div style={styles.formGrid}>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Gender Classification</label>
//                   <div style={{ display: 'flex', gap: '16px', marginTop: '6px' }}>
//                     {['Male', 'Female', 'Other'].map((g) => (
//                       <label key={g} style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
//                         <input type="radio" name="gender" checked={formData.gender === g} onChange={() => setFormData({...formData, gender: g})} style={{ cursor: 'pointer' }} />
//                         {g}
//                       </label>
//                     ))}
//                   </div>
//                 </div>

//                 <div style={{ display: 'flex', alignItems: 'center', paddingTop: '12px' }}>
//                   <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
//                     <input type="checkbox" checked={formData.isWhatsApp} onChange={(e) => setFormData({...formData, isWhatsApp: e.target.checked})} />
//                     <span>Active on WhatsApp?</span>
//                   </label>
//                 </div>
//               </div>

//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Select Structural Requirement Veneer Material</label>
//                 <select value={formData.requirement} onChange={(e) => setFormData({...formData, requirement: e.target.value})} style={styles.select}>
//                   {productRequirements.map((item, index) => (
//                     <option key={index} value={item}>{item}</option>
//                   ))}
//                 </select>
//               </div>

//               <div style={styles.formGrid}>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Assign Sales Executive Rep</label>
//                   <select value={formData.executive} onChange={(e) => setFormData({...formData, executive: e.target.value})} style={styles.select}>
//                     <option value="Se1">Se1 (se1@gmail.com)</option>
//                     <option value="Se2">Se2 (se2@gmail.com)</option>
//                   </select>
//                 </div>

//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Lead Pipeline State Status</label>
//                   <select value={formData.status} onChange={(e) => setFormData({...formData, status: e.target.value})} style={{ ...styles.select, fontWeight: 'bold' }}>
//                     <option value="LEAD">LEAD</option>
//                     <option value="INTERESTED">INTERESTED</option>
//                     <option value="CALLBACK">CALLBACK</option>
//                     <option value="NOT INTERESTED">NOT INTERESTED</option>
//                   </select>
//                 </div>
//               </div>

//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Activity Comment / Interaction Logs Note</label>
//                 <textarea rows={2} value={formData.comment} onChange={(e) => setFormData({...formData, comment: e.target.value})} placeholder="Enter notes concerning conversation logs..." style={styles.textarea} />
//               </div>

//               <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
//                 <button type="button" onClick={() => setIsModalOpen(false)} style={styles.btnSec}>Cancel</button>
//                 <button type="submit" style={styles.btnPri}>{editingLead ? 'Update Log' : 'Save Lead'}</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Pipeline Context State Action Modal */}
//       {statusAction && actionLead && (
//         <div style={styles.modalOverlay}>
//           <div style={styles.modalContainer('400px')}>
//             <div style={{
//               ...styles.modalHeader,
//               backgroundColor: statusAction === 'INTERESTED' ? '#ecfdf5' : statusAction === 'CALLBACK' ? '#fffbeb' : '#fff5f5'
//             }}>
//               <div>
//                 <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '700', color: statusAction === 'INTERESTED' ? '#047857' : statusAction === 'CALLBACK' ? '#b45309' : '#c53030' }}>
//                   Update Status — {statusAction === 'NOT_INTERESTED' ? 'NOT INTERESTED' : statusAction}
//                 </h3>
//                 <p style={{ margin: '2px 0 0 0', fontSize: '12px', color: '#6b7280' }}>{actionLead.name}</p>
//               </div>
//               <button onClick={closeStatusAction} style={{ ...styles.actBtn('def'), border: 'none', backgroundColor: 'transparent' }}>
//                 <X style={{ width: '16px', height: '16px' }} />
//               </button>
//             </div>

//             <form onSubmit={submitStatusAction} style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
//               {(statusAction === 'INTERESTED' || statusAction === 'CALLBACK') && (
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Date of Visit *</label>
//                   <input type="datetime-local" required value={actionDate} onChange={e => setActionDate(e.target.value)} style={styles.input} />
//                 </div>
//               )}

//               {statusAction === 'NOT_INTERESTED' && (
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Reason for Drop *</label>
//                   <select required value={actionReason} onChange={e => setActionReason(e.target.value)} style={styles.select}>
//                     <option value="">Select a reason</option>
//                     {NOT_INTERESTED_REASONS.map(r => (
//                       <option key={r} value={r}>{r}</option>
//                     ))}
//                   </select>
//                 </div>
//               )}

//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Comment</label>
//                 <textarea rows={3} value={actionComment} onChange={e => setActionComment(e.target.value)} placeholder="Add a note..." style={styles.textarea} />
//               </div>

//               <div style={{ display: 'flex', gap: '12px', paddingTop: '12px', borderTop: '1px solid #e5e7eb' }}>
//                 <button type="button" onClick={closeStatusAction} style={{ ...styles.btnSec, flex: 1, justifyContent: 'center' }}>Cancel</button>
//                 <button type="submit" style={{
//                   ...styles.btnPri,
//                   flex: 1,
//                   justifyContent: 'center',
//                   backgroundColor: statusAction === 'INTERESTED' ? '#059669' : statusAction === 'CALLBACK' ? '#d97706' : '#dc2626'
//                 }}>Submit</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default LeadManagement;


import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import {
  FaBullseye,
  FaPlus,
  FaSearch,
  FaUser,
  FaVenusMars,
  FaList,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaEnvelope,
  FaPhone,
  FaTrash,
  FaTimes,
  FaEdit
} from 'react-icons/fa';
import * as XLSX from 'xlsx';
import {
  Trash2,
  Edit,
  ThumbsUp,
  ThumbsDown,
  PhoneCall
} from 'lucide-react';

// Modern Clean Minimal UI Inline Styles Map
const styles = {
  container: { maxWidth: '1280px', margin: '0 auto', fontFamily: 'system-ui, -apple-system, sans-serif', backgroundColor: '#f9fafb', color: '#111827' },
  headerSection: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '16px', marginBottom: '24px' },
  title: { fontSize: '24px', fontWeight: '900', letterSpacing: '-0.5px', margin: '0 0 4px 0', color: '#273179', display: 'flex', alignItems: 'center', gap: '10px' },
  subtitle: { fontSize: '13px', color: '#6b7280', margin: 0 },
  btnGroup: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px' },
  btnSec: { display: 'flex', alignItems: 'center', gap: '6px', padding: '10px 14px', border: '1px solid #e5e7eb', borderRadius: '8px', backgroundColor: '#ffffff', color: '#4b5563', fontSize: '13px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s' },
  btnPri: { display: 'flex', alignItems: 'center', gap: '6px', padding: '10px 16px', border: 'none', borderRadius: '8px', backgroundColor: '#2563eb', color: '#ffffff', fontSize: '13px', fontWeight: '700', cursor: 'pointer', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)', transition: 'all 0.2s' },
  filterCard: { backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', marginBottom: '24px', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '16px' },
  tabWrapper: { display: 'flex', gap: '4px', overflowX: 'auto', paddingBottom: '2px' },
  tabBtn: (isActive) => ({ padding: '8px 14px', borderRadius: '8px', fontSize: '12px', fontWeight: '700', border: isActive ? '1px solid rgba(37,99,235,0.2)' : '1px solid transparent', backgroundColor: isActive ? 'rgba(37,99,235,0.1)' : 'transparent', color: isActive ? '#2563eb' : '#6b7280', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s' }),
  searchWrapper: { position: 'relative', width: '100%', maxWidth: '320px' },
  searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '14px', height: '14px', color: '#9ca3af' },
  searchInput: { width: '100%', padding: '10px 12px 10px 36px', fontSize: '13px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', outline: 'none', color: '#111827', boxSizing: 'border-box' },
  tableWrapper: { backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' },
  table: { width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '12px' },
  thead: { backgroundColor: '#f3f4f6', color: '#6b7280', textTransform: 'uppercase', fontSize: '10px', letterSpacing: '0.05em', borderBottom: '1px solid #e5e7eb' },
  th: { padding: '12px 16px', fontWeight: '700' },
  tr: { borderBottom: '1px solid #e5e7eb', transition: 'background-color 0.2s' },
  td: { padding: '14px 16px', verticalAlign: 'middle', color: '#374151' },
  profileName: { fontWeight: '700', fontSize: '13px', color: '#111827', display: 'block' },
  contactItem: { display: 'flex', alignItems: 'center', gap: '6px', fontFamily: 'monospace', color: '#111827', fontWeight: '600' },
  badgeWa: { fontSize: '9px', backgroundColor: 'rgba(16,185,129,0.1)', color: '#059669', padding: '1px 4px', borderRadius: '4px', fontFamily: 'sans-serif' },
  badgeStatus: (status) => {
    let bg = '#eee', text = '#333';
    if (status === 'LEAD') { bg = '#dbeafe'; text = '#1e40af'; }
    else if (status === 'INTERESTED') { bg = '#d1fae5'; text = '#065f46'; }
    else if (status === 'CALLBACK') { bg = '#fef3c7'; text = '#92400e'; }
    else if (status === 'NOT_INTERESTED' || status === 'NOT INTERESTED') { bg = '#ffe4e6'; text = '#9f1239'; }
    return { padding: '4px 10px', borderRadius: '9999px', fontSize: '10px', fontWeight: '800', textTransform: 'uppercase', display: 'inline-block', backgroundColor: bg, color: text };
  },
  actionGroup: { display: 'flex', alignItems: 'center', gap: '6px' },
  actBtn: (type) => {
    let bg = '#f3f4f6', border = '#e5e7eb', text = '#4b5563';
    if (type === 'int') { bg = '#ecfdf5'; border = '#a7f3d0'; text = '#047857'; }
    else if (type === 'cb') { bg = '#fffbeb'; border = '#fde68a'; text = '#b45309'; }
    else if (type === 'ni' || type === 'del') { bg = '#fff5f5'; border = '#fed7d7'; text = '#c53030'; }
    else if (type === 'edit') { bg = '#eff6ff'; border = '#bfdbfe'; text = '#1d4ed8'; }
    return { padding: '8px', borderRadius: '6px', border: `1px solid ${border}`, backgroundColor: bg, color: text, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s' };
  },
  footer: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', borderTop: '1px solid #e5e7eb', flexWrap: 'wrap', gap: '12px' },
  pageBtn: (isActive) => ({ padding: '8px 14px', borderRadius: '8px', fontSize: '12px', fontWeight: '500', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', border: isActive ? 'none' : '1px solid #e5e7eb', backgroundColor: isActive ? '#2563eb' : '#ffffff', color: isActive ? '#ffffff' : '#6b7280' }),
  modalOverlay: { position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', backdropFilter: 'blur(4px)' },
  modalContainer: (maxW = '576px') => ({ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '16px', width: '100%', maxWidth: maxW, boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)', maxHeight: '90vh', overflowY: 'auto' }),
  modalHeader: { padding: '16px 24px', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px' },
  formGroup: { display: 'flex', flexDirection: 'column', gap: '4px' },
  label: { fontSize: '12px', fontWeight: '600', color: '#6b7280' },
  input: { padding: '10px 12px', fontSize: '13px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', outline: 'none', color: '#111827', width: '100%', boxSizing: 'border-box' },
  select: { padding: '10px 12px', fontSize: '13px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', outline: 'none', color: '#111827', width: '100%', boxSizing: 'border-box' },
  textarea: { padding: '10px 12px', fontSize: '13px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', outline: 'none', color: '#111827', resize: 'none', width: '100%', boxSizing: 'border-box' },

  // Mobile Card Responsive System
  mobileCard: { backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', marginBottom: '12px', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' },
  mobileRow: { display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px dashed #f3f4f6', fontSize: '13px' }
};

const LeadManagement = () => {
  const [showForm, setShowForm] = useState(false);
  const [leads, setLeads] = useState([]);
  const [editLeadId, setEditLeadId] = useState(null);
  const [executives, setExecutives] = useState([]);
  const [assignedExecutive, setAssignedExecutive] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [formData, setFormData] = useState({
    name: '',
    Comment: '',
    email: '',
    contact: '',
    gender: '',
    requirement: '',
    location: '',
    quantity: "",
    createdDate: ''
  });
  const [isWhatsapp, setIsWhatsapp] = useState(true);
  const [alternateWhatsapp, setAlternateWhatsapp] = useState('');
  const [selectedStatus, setSelectedStatus] = useState("LEAD");

  const [currentPage, setCurrentPage] = useState(1);
  const leadsPerPage = 10;

  // Filter Pipeline Engine
  const filteredLeads = leads.filter(lead => {
    const matchesStatus = (lead.status || "LEAD") === selectedStatus;
    const search = searchTerm.toLowerCase();
    const matchesSearch =
      lead.name?.toLowerCase().includes(search) ||
      lead.email?.toLowerCase().includes(search) ||
      lead.contact?.toLowerCase().includes(search);

    return matchesStatus && matchesSearch;
  });

  const indexOfLastLead = currentPage * leadsPerPage;
  const indexOfFirstLead = indexOfLastLead - leadsPerPage;
  const currentLeads = filteredLeads.slice(indexOfFirstLead, indexOfLastLead);
  const totalPages = Math.ceil(filteredLeads.length / leadsPerPage);

  const user = JSON.parse(sessionStorage.getItem("userData")) || {};

  const showExecutiveSelect =
    user?.type === "company" ||
    (user?.type === "employee" && user?.user_type === "Manager");

  useEffect(() => {
    if (!showExecutiveSelect || !user.id) return;

    const payload =
      user.type === "company"
        ? { company_id: user.id }
        : { manager_id: user.id };

    fetch("https://cloudapi.emedhatechnologies.com/pages/api/api/get-sales-executives", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) setExecutives(data.data);
      });
  }, [showExecutiveSelect]);

  useEffect(() => {
    fetchLeads();
  }, []);

  const fetchLeads = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem("userData"));
      if (!user) {
        console.warn("User data not found in sessionStorage");
        return;
      }
      const params = {
        user_id: user.type === "company" ? user.id : user.parent_company_id,
      };
      if (user.type === "company") {
        params.role = "company";
      } else if (user.type === "employee" && user.user_type === "Manager") {
        params.role = "manager";
        params.employee_id = user.id;
      } else if (user.type === "employee" && user.user_type === "Executive") {
        params.role = "executive";
        params.employee_id = user.id;
      }

      const response = await axios.post('https://cloudapi.emedhatechnologies.com/pages/api/api/new/leads',
        params
      );
      setLeads(response.data);
    } catch (err) {
      console.error('Error fetching leads:', err);
    }
  };

  const toggleForm = () => {
    if (showForm) {
      resetForm();
    } else {
      setFormData(prev => ({
        ...prev,
        createdDate: new Date().toISOString().slice(0, 16)
      }));
      setShowForm(true);
    }
  };

  const handleInputChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const validateForm = () => {
    const errors = [];
    if (!formData.name.trim()) errors.push("Lead Name is required.");
    if (!formData.email.trim()) {
      errors.push("Email is required.");
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.push("Invalid email format.");
    }
    if (!formData.contact.trim()) {
      errors.push("Contact number is required.");
    } else if (!/^\d{10,15}$/.test(formData.contact)) {
      errors.push("Contact number should be 10-15 digits.");
    }
    if (!formData.gender) errors.push("Gender is required.");
    if (!formData.requirement.trim()) errors.push("Requirement is required.");
    if (!formData.location.trim()) errors.push("Location is required.");
    if (!formData.createdDate.trim()) {
      errors.push("Created date is required.");
    } else if (isNaN(Date.parse(formData.createdDate))) {
      errors.push("Invalid created date.");
    }
    return errors;
  };

  const handleSubmitLead = async () => {
    const errors = validateForm();
    if (errors.length > 0) {
      alert(errors.join('\n'));
      return;
    }
    const user = JSON.parse(sessionStorage.getItem("userData"));
    const companyId = user.type === "company" ? user.id : user.parent_company_id;

    let executiveId = null;
    if (user.type === "employee" && user.user_type === "Executive") {
      executiveId = user.id;
    } else {
      executiveId = assignedExecutive || null;
    }

    const createdByType =
      user.type === "company"
        ? "company"
        : user.user_type === "Manager"
          ? "manager"
          : "executive";

    const dataToSend = {
      ...formData,
      user_id: companyId,
      created_by: user.id,
      created_by_type: createdByType,
      updated_by: user.id,
      executive_id: executiveId,
      isWhatsapp,
      alternateWhatsapp: isWhatsapp ? formData.contact : alternateWhatsapp,
    };

    try {
      if (editLeadId) {
        await axios.put(`https://cloudapi.emedhatechnologies.com/pages/api/lead_management/${editLeadId}`, dataToSend);
      } else {
        await axios.post('https://cloudapi.emedhatechnologies.com/pages/api/lead_management', dataToSend);
      }
      fetchLeads();
      resetForm();
    } catch (err) {
      console.error('Error saving lead:', err);
    }
  };

  const handleEditLead = (lead) => {
    setFormData({
      name: lead.name || '',
      Comment: lead.Comment || '',
      email: lead.email || '',
      contact: lead.contact || '',
      gender: lead.gender || '',
      requirement: lead.requirement || '',
      location: lead.location || '',
      quantity: lead.quantity || '',
      createdDate: lead.createdDate ? lead.createdDate.split('T')[0] : ''
    });

    setAssignedExecutive(lead.executive_id || '');
    setEditLeadId(lead.id);
    setShowForm(true);
  };

  const resetForm = () => {
    setFormData({
      name: '',
      Comment: '',
      email: '',
      contact: '',
      gender: '',
      requirement: '',
      location: '',
      quantity: '',
      createdDate: ''
    });
    setEditLeadId(null);
    setShowForm(false);
  };

  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusUpdateData, setStatusUpdateData] = useState({
    id: null,
    status: '',
    visitDate: '',
    statusComment: '',
    notInterestedReason: '',
  });

  const openStatusModal = (id, status) => {
    setStatusUpdateData({
      id,
      status,
      visitDate: '',
      statusComment: '',
      notInterestedReason: '',
    });
    setShowStatusModal(true);
  };

  const handleSubmitStatusUpdate = async () => {
    const { id, status, visitDate, statusComment, notInterestedReason } = statusUpdateData;

    if ((status === 'INTERESTED' || status === 'CALLBACK') && !visitDate) {
      alert("Visit date is required.");
      return;
    }
    if (status === 'NOT_INTERESTED' && !notInterestedReason) {
      alert("Please select a reason.");
      return;
    }

    try {
      const payload = {
        status,
        visitDate: visitDate || null,
        statusComment: statusComment || '',
        notInterestedReason: status === 'NOT_INTERESTED' ? notInterestedReason : null
      };

      await axios.put(`https://cloudapi.emedhatechnologies.com/pages/api/conertedapi/${id}`, payload);
      fetchLeads();
      setShowStatusModal(false);
    } catch (err) {
      console.error('Error updating status:', err);
      alert("Failed to update status.");
    }
  };

  const handleDeleteLead = async (indexToDelete) => {
    const leadId = leads[indexToDelete].id;
    try {
      await axios.delete(`https://cloudapi.emedhatechnologies.com/pages/api/lead_management/${leadId}`);
      fetchLeads();
      if ((currentPage - 1) * leadsPerPage >= leads.length - 1 && currentPage > 1) {
        setCurrentPage(prev => prev - 1);
      }
    } catch (err) {
      console.error('Error deleting lead:', err);
    }
  };

  const fileInputRef = useRef(null);
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const user = JSON.parse(sessionStorage.getItem("userData"));
    const companyId = user.type === "company" ? user.id : user.parent_company_id;

    let executiveId = null;
    if (user.type === "employee" && user.user_type === "Executive") {
      executiveId = user.id;
    }

    const createdByType =
      user.type === "company"
        ? "company"
        : user.user_type === "Manager"
          ? "manager"
          : "executive";

    try {
      const reader = new FileReader();
      reader.onload = async (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        const parsedData = jsonData.map(row => {
          if (typeof row.createdDate === 'number') {
            const excelEpoch = new Date(Date.UTC(1899, 11, 30));
            const jsDate = new Date(excelEpoch.getTime() + row.createdDate * 24 * 60 * 60 * 1000);
            row.createdDate = jsDate.toISOString().slice(0, 10);
          }
          return {
            ...row,
            user_id: companyId,
            created_by: user.id,
            created_by_type: createdByType,
            updated_by: user.id,
            executive_id: executiveId,
          };
        });

        await axios.post('https://cloudapi.emedhatechnologies.com/pages/api/lead_management/bulk', parsedData);
        alert('Leads uploaded successfully!');
        fetchLeads();
      };
      reader.readAsArrayBuffer(file);
    } catch (err) {
      console.error('Error reading Excel file:', err);
      alert('Invalid Excel file format.');
    }
  };

  const handleDownloadDemoExcel = () => {
    const sampleLeads = [
      {
        name: "John Doe",
        Comment: "Interested in product A",
        email: "john@example.com",
        contact: "9876543210",
        gender: "Male",
        requirement: "Product A",
        quantity: 20,
        location: "Mumbai",
        alternateWhatsapp: "9876543210",
        createdDate: new Date().toISOString().slice(0, 10),
        isWhatsapp: true
      },
      {
        name: "Jane Smith",
        Comment: "Requested callback",
        email: "jane@example.com",
        contact: "9123456789",
        gender: "Female",
        requirement: "Service B",
        quantity: 40,
        location: "Delhi",
        alternateWhatsapp: "9123456789",
        createdDate: new Date().toISOString().slice(0, 10),
        isWhatsapp: false
      }
    ];

    const worksheet = XLSX.utils.json_to_sheet(sampleLeads);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "SampleLeads");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Lead_Demo_Template.xlsx";
    link.click();
    URL.revokeObjectURL(url);
  };

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("userData"));
    if (!user) return;
    const userId = user.type === "employee" ? user.parent_company_id : user.id;
    if (userId) {
      fetch(`https://cloudapi.emedhatechnologies.com/pages/api/api/products/${userId}`)
        .then(res => res.json())
        .then(data => setCategories(data))
        .catch(err => console.error("Error fetching categories:", err));
    }
  }, []);

  const handleCallClick = (contact) => {
    window.location.href = `tel:${contact}`;
  };

  const maskEmail = (email) => {
    if (!email) return '';
    const [user, domain] = email.split('@');
    if (!domain) return email;
    const visibleUser = user.slice(0, 2);
    const maskedUser = '*'.repeat(user.length - 2);
    return `${visibleUser}${maskedUser}@${domain}`;
  };

  return (
    <div style={styles.container}>
      {/* Dynamic Native View Responsiveness Rule Sheet Injection */}
      <style>{`
        .desktop-view-only { display: block !important; }
        .mobile-view-only { display: none !important; }
        @media (max-width: 991px) {
          .desktop-view-only { display: none !important; }
          .mobile-view-only { display: block !important; }
        }
      `}</style>

      {/* Top Header section */}
      <div style={styles.headerSection}>
        <div>
          <h2 style={styles.title}><FaBullseye /> Lead Management</h2>
          <p style={styles.subtitle}>Organize leads and track their progress effectively here</p>
        </div>

        <div style={styles.btnGroup}>
          <button onClick={toggleForm} style={{ ...styles.btnPri, backgroundColor: showForm ? '#dc3545' : '#2563eb' }}>
            {showForm ? <FaTimes /> : <FaPlus />}
            <span>{showForm ? 'Close Window' : 'Add Lead'}</span>
          </button>

          <button onClick={handleUploadClick} style={styles.btnSec}>
            <FaPlus /> Bulk Upload Lead
          </button>
          <input type="file" accept=".xlsx, .xls" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} />

          <button onClick={handleDownloadDemoExcel} style={styles.btnSec}>
            Excel Demo File
          </button>
        </div>
      </div>

      {/* Pipeline Filter Controls & Global Search Grid Container */}
      <div style={styles.filterCard}>
        <div style={styles.tabWrapper}>
          {["LEAD", "INTERESTED", "CALLBACK", "NOT_INTERESTED"].map((tab) => (
            <button
              key={tab}
              onClick={() => { setSelectedStatus(tab); setCurrentPage(1); }}
              style={styles.tabBtn(selectedStatus === tab)}
            >
              {tab === "NOT_INTERESTED" ? "NOT INTERESTED" : tab} ({leads.filter(l => (l.status || "LEAD") === tab).length})
            </button>
          ))}
        </div>

        <div style={styles.searchWrapper}>
          <FaSearch style={styles.searchIcon} />
          <input
            type="text"
            placeholder="Search by Name, Email, Contact..."
            value={searchTerm}
            onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
            style={styles.searchInput}
          />
        </div>
      </div>

      {/* Desktop Main Structural Data Layout View */}
      <div className="desktop-view-only" style={{ display: 'none' }}>
        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead style={styles.thead}>
              <tr>
                <th style={styles.th}><FaUser style={{ marginRight: '6px' }} />Name</th>
                <th style={styles.th}><FaPhone style={{ marginRight: '6px' }} />Mobile</th>
                <th style={styles.th}><FaEnvelope style={{ marginRight: '6px' }} />Email</th>
                <th style={styles.th}><FaVenusMars style={{ marginRight: '6px' }} />Gender</th>
                <th style={styles.th}><FaList style={{ marginRight: '6px' }} />Requirement</th>
                <th style={styles.th}><FaMapMarkerAlt style={{ marginRight: '6px' }} />Location</th>
                <th style={styles.th}><FaCalendarAlt style={{ marginRight: '6px' }} />Created Date</th>
                <th style={styles.th}><FaUser style={{ marginRight: '6px' }} />Comment</th>
                <th style={styles.th}>Actions</th>
                <th style={{ ...styles.th, textAlign: 'center' }}>Pipeline Status Workflow</th>
              </tr>
            </thead>
            <tbody>
              {filteredLeads.length === 0 ? (
                <tr>
                  <td colSpan="10" style={{ ...styles.td, textAlign: 'center', padding: '32px', color: '#6b7280' }}>
                    No records found matching current pipeline filter criteria.
                  </td>
                </tr>
              ) : (
                currentLeads.map((lead, index) => (
                  <tr key={lead.id || index} style={styles.tr}>
                    <td style={{ ...styles.td, fontWeight: '700', color: '#111827' }}>{lead.name}</td>
                    <td style={styles.td}>
                      <div style={styles.contactItem}>
                        <FaPhone onClick={() => handleCallClick(lead.contact)} style={{ color: '#2563eb', cursor: 'pointer' }} title="Call Client" />
                        <span>{lead.contact}</span>
                        {lead.isWhatsapp && <span style={styles.badgeWa}>WhatsApp</span>}
                      </div>
                    </td>
                    <td style={styles.td}>{maskEmail(lead.email)}</td>
                    <td style={styles.td}>{lead.gender}</td>
                    <td style={styles.td}>
                      <span style={{ fontWeight: '500' }}>{lead.requirement}</span>
                      {lead.quantity && <div style={{ color: '#6b7280', fontSize: '11px' }}>Qty: {lead.quantity}</div>}
                    </td>
                    <td style={styles.td}>{lead.location}</td>
                    <td style={{ ...styles.td, fontFamily: 'monospace' }}>
                      {lead.createdDate ? new Date(lead.createdDate).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }) : ''}
                    </td>
                    <td style={styles.td}>
                      <span style={{ color: lead.Comment ? '#374151' : '#9ca3af', fontStyle: lead.Comment ? 'normal' : 'italic' }}>
                        {lead.Comment || 'No commentary logs'}
                      </span>
                    </td>
                    <td style={styles.td}>
                      <div style={styles.actionGroup}>
                        <button onClick={() => handleEditLead(lead)} style={styles.actBtn('edit')} title="Edit Record">
                          <Edit style={{ width: '14px', height: '14px' }} />
                        </button>
                        <button onClick={() => handleDeleteLead(indexOfFirstLead + index)} style={styles.actBtn('del')} title="Delete Record">
                          <Trash2 style={{ width: '14px', height: '14px' }} />
                        </button>
                      </div>
                    </td>
                    <td style={styles.td}>
                      <div style={{ ...styles.actionGroup, justifyContent: 'center' }}>
                        {lead.status !== 'INTERESTED' && (
                          <button title="Move to INTERESTED" onClick={() => openStatusModal(lead.id, "INTERESTED")} style={styles.actBtn('int')}><ThumbsUp style={{ width: '14px', height: '14px' }} /></button>
                        )}
                        {lead.status !== 'CALLBACK' && (
                          <button title="Schedule CALLBACK" onClick={() => openStatusModal(lead.id, "CALLBACK")} style={styles.actBtn('cb')}><PhoneCall style={{ width: '14px', height: '14px' }} /></button>
                        )}
                        {(lead.status !== 'NOT_INTERESTED' && lead.status !== 'NOT INTERESTED') && (
                          <button title="Drop to NOT INTERESTED" onClick={() => openStatusModal(lead.id, "NOT_INTERESTED")} style={styles.actBtn('ni')}><ThumbsDown style={{ width: '14px', height: '14px' }} /></button>
                        )}
                        {/* <span style={{ ...styles.badgeStatus(lead.status || 'LEAD'), marginLeft: '6px' }}>{lead.status || 'LEAD'}</span> */}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile Stack Responsive View Card Stream */}
      <div className="mobile-view-only" style={{ display: 'none' }}>
        {filteredLeads.length === 0 ? (
          <div style={{ ...styles.mobileCard, textAlign: 'center', color: '#6b7280', padding: '24px' }}>
            No leads found for this view pipeline stage.
          </div>
        ) : (
          currentLeads.map((lead, index) => (
            <div key={lead.id || index} style={styles.mobileCard}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <strong style={{ fontSize: '15px', color: '#111827' }}>{lead.name}</strong>
                <span style={styles.badgeStatus(lead.status || 'LEAD')}>{lead.status || 'LEAD'}</span>
              </div>
              <div style={styles.mobileRow}>
                <span style={{ color: '#6b7280' }}>Contact</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px', fontWeight: 'bold' }}>
                  <FaPhone onClick={() => handleCallClick(lead.contact)} style={{ color: '#2563eb', cursor: 'pointer' }} />
                  {lead.contact}
                </span>
              </div>
              <div style={styles.mobileRow}>
                <span style={{ color: '#6b7280' }}>Email</span>
                <span>{maskEmail(lead.email)}</span>
              </div>
              <div style={styles.mobileRow}>
                <span style={{ color: '#6b7280' }}>Requirement</span>
                <span style={{ fontWeight: '500' }}>{lead.requirement} {lead.quantity ? `(Qty: ${lead.quantity})` : ''}</span>
              </div>
              <div style={styles.mobileRow}>
                <span style={{ color: '#6b7280' }}>Location</span>
                <span>{lead.location}</span>
              </div>
              <div style={styles.mobileRow}>
                <span style={{ color: '#6b7280' }}>Created</span>
                <span style={{ fontFamily: 'monospace' }}>{lead.createdDate ? new Date(lead.createdDate).toLocaleDateString('en-GB') : ''}</span>
              </div>
              {lead.Comment && (
                <div style={{ ...styles.mobileRow, flexDirection: 'column', gap: '2px' }}>
                  <span style={{ color: '#6b7280' }}>Last Note Comment</span>
                  <p style={{ margin: 0, fontSize: '12px', color: '#374151', backgroundColor: '#f3f4f6', padding: '6px 10px', borderRadius: '6px' }}>{lead.Comment}</p>
                </div>
              )}

              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '12px', justifyContent: 'flex-end', paddingTop: '10px', borderTop: '1px solid #f3f4f6' }}>
                <button onClick={() => handleEditLead(lead)} style={styles.actBtn('edit')}><FaEdit /> <span style={{ marginLeft: '4px', fontSize: '11px' }}>Edit</span></button>
                <button onClick={() => handleDeleteLead(indexOfFirstLead + index)} style={styles.actBtn('del')}><FaTrash /> <span style={{ marginLeft: '4px', fontSize: '11px' }}>Delete</span></button>

                {lead.status !== 'INTERESTED' && (
                  <button onClick={() => openStatusModal(lead.id, "INTERESTED")} style={styles.actBtn('int')}><FaBullseye /> <span style={{ marginLeft: '4px', fontSize: '11px' }}>Interested</span></button>
                )}
                {lead.status !== 'CALLBACK' && (
                  <button onClick={() => openStatusModal(lead.id, "CALLBACK")} style={styles.actBtn('cb')}><FaPhone /> <span style={{ marginLeft: '4px', fontSize: '11px' }}>Callback</span></button>
                )}
                {(lead.status !== 'NOT_INTERESTED' && lead.status !== 'NOT INTERESTED') && (
                  <button onClick={() => openStatusModal(lead.id, "NOT_INTERESTED")} style={styles.actBtn('ni')}><FaTrash /> <span style={{ marginLeft: '4px', fontSize: '11px' }}>Drop</span></button>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Global Pagination Grid Node Footer */}
      <div style={{ textAlign: 'center', marginTop: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
        <button
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          style={{ ...paginationBtn(currentPage > 1), ...styles.pageBtn(false), opacity: currentPage === 1 ? 0.4 : 1 }}
        >
          Previous
        </button>
        <span style={{ margin: '0 8px', fontSize: '13px', fontWeight: '600', color: '#4b5563' }}>
          Page {currentPage} of {totalPages || 1}
        </span>
        <button
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages || totalPages === 0}
          style={{ ...paginationBtn(currentPage < totalPages), ...styles.pageBtn(false), opacity: (currentPage === totalPages || totalPages === 0) ? 0.4 : 1 }}
        >
          Next
        </button>
      </div>

      {/* Add Lead Form Window Modal Overlay */}
      {showForm && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContainer('750px')}>
            <div style={styles.modalHeader}>
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '900', color: '#111827' }}>{editLeadId ? 'Modify Existing Lead Parameters' : 'Add New Client Prospect Segment'}</h3>
                <p style={{ margin: '2px 0 0 0', fontSize: '12px', color: '#6b7280' }}>Input parameters relative to core enterprise verification logs.</p>
              </div>
              <button onClick={toggleForm} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#9ca3af' }}><FaTimes /></button>
            </div>

            <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={styles.formGrid}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Full Name *</label>
                  <input name="name" value={formData.name} onChange={handleInputChange} placeholder="Full Name" style={styles.input} />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Email Address *</label>
                  <input name="email" value={formData.email} onChange={handleInputChange} placeholder="client@domain.com" style={styles.input} />
                </div>
              </div>

              <div style={styles.formGrid}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Mobile Number *</label>
                  <input name="contact" value={formData.contact} onChange={handleInputChange} placeholder="Mobile No" style={styles.input} />
                </div>
                <div style={{ ...styles.formGroup, justifyContent: 'center', paddingTop: '16px' }}>
                  <label style={{ fontSize: '13px', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                    <input type="checkbox" checked={isWhatsapp} onChange={() => setIsWhatsapp(prev => !prev)} />
                    <span>Is this your active WhatsApp?</span>
                  </label>
                </div>
              </div>

              {!isWhatsapp && (
                <div style={styles.formGroup}>
                  <label style={styles.label}>Alternate WhatsApp Connection Node</label>
                  <input name="alternateWhatsapp" value={alternateWhatsapp} onChange={(e) => setAlternateWhatsapp(e.target.value)} placeholder="Enter WhatsApp No" style={styles.input} />
                </div>
              )}

              <div style={styles.formGrid}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Gender Classification *</label>
                  <select name="gender" value={formData.gender} onChange={handleInputChange} style={styles.select}>
                    <option value="">Select Gender</option>
                    <option>Male</option>
                    <option>Female</option>
                    <option>Other</option>
                  </select>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Geographic Location / City *</label>
                  <input name="location" value={formData.location} onChange={handleInputChange} placeholder="Enter Location" style={styles.input} />
                </div>
              </div>

              <div style={styles.formGrid}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Creation Timestamp Registry *</label>
                  <input name="createdDate" type="datetime-local" value={formData.createdDate} onChange={handleInputChange} style={styles.input} />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Veneer Material System Requirement *</label>
                  <select name="requirement" value={formData.requirement} onChange={handleInputChange} style={styles.select}>
                    <option value="">Select Requirement</option>
                    {categories.map((category, index) => (
                      <option key={index} value={category.category}>
                        {category.category} - {category.subcategory}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div style={styles.formGrid}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Volume Order Quantity</label>
                  <input name="quantity" value={formData.quantity} onChange={handleInputChange} placeholder="Quantity" style={styles.input} />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Executive Assignment Strategy Pipeline</label>
                  {showExecutiveSelect ? (
                    <select value={assignedExecutive} onChange={(e) => setAssignedExecutive(e.target.value)} style={styles.select}>
                      <option value="">Assign Sales Executive</option>
                      {executives.map(exec => (
                        <option key={exec.id} value={exec.id}>
                          {exec.name} ({exec.email})
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input disabled value="Auto-Assigned Layer Configuration" style={{ ...styles.input, backgroundColor: '#e5e7eb', color: '#6b7280', cursor: 'not-allowed' }} />
                  )}
                </div>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Interaction Comments / Logs</label>
                <textarea name="Comment" value={formData.Comment} onChange={handleInputChange} placeholder="Enter operational observation logs..." rows={2} style={styles.textarea} />
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
                <button onClick={handleSubmitLead} style={{ ...styles.btnPri, width: '100%', maxWidth: '320px', justifyContent: 'center', padding: '12px' }}>
                  {editLeadId ? 'Update Lead File Log' : 'Save New Core Lead'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Action Workflow Modal Window */}
      {showStatusModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContainer('440px')}>
            <div style={{
              ...styles.modalHeader,
              backgroundColor: statusUpdateData.status === 'INTERESTED' ? '#ecfdf5' : statusUpdateData.status === 'CALLBACK' ? '#fffbeb' : '#fff5f5'
            }}>
              <div>
                <h4 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: statusUpdateData.status === 'INTERESTED' ? '#047857' : statusUpdateData.status === 'CALLBACK' ? '#b45309' : '#c53030' }}>
                  Update Status Matrix — {statusUpdateData.status === 'NOT_INTERESTED' ? 'NOT INTERESTED' : statusUpdateData.status}
                </h4>
              </div>
              <button onClick={() => setShowStatusModal(false)} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#6b7280' }}><FaTimes /></button>
            </div>

            <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {(statusUpdateData.status === 'INTERESTED' || statusUpdateData.status === 'CALLBACK') && (
                <div style={styles.formGroup}>
                  <label style={styles.label}>Date of Scheduled Client Visit *</label>
                  <input type="datetime-local" value={statusUpdateData.visitDate} onChange={(e) => setStatusUpdateData(prev => ({ ...prev, visitDate: e.target.value }))} style={styles.input} />
                </div>
              )}

              {statusUpdateData.status === 'NOT_INTERESTED' && (
                <div style={styles.formGroup}>
                  <label style={styles.label}>Core Pipeline Reason for Drop *</label>
                  <select value={statusUpdateData.notInterestedReason} onChange={(e) => setStatusUpdateData(prev => ({ ...prev, notInterestedReason: e.target.value }))} style={styles.select}>
                    <option value="">Select an analytical reason</option>
                    <option value="Budget">Budget constraints</option>
                    <option value="Time">Timeline misalignment</option>
                    <option value="Location">Geographic logistics drop</option>
                  </select>
                </div>
              )}

              <div style={styles.formGroup}>
                <label style={styles.label}>Operational Status Commentary Log</label>
                <textarea value={statusUpdateData.statusComment} onChange={(e) => setStatusUpdateData(prev => ({ ...prev, statusComment: e.target.value }))} rows={3} placeholder="Add detailed operational note description..." style={styles.textarea} />
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', pt: '12px', borderTop: '1px solid #e5e7eb' }}>
                <button onClick={() => setShowStatusModal(false)} style={styles.btnSec}>Cancel</button>
                <button onClick={handleSubmitStatusUpdate} style={{
                  ...styles.btnPri,
                  backgroundColor: statusUpdateData.status === 'INTERESTED' ? '#059669' : statusUpdateData.status === 'CALLBACK' ? '#d97706' : '#dc2626'
                }}>Submit Update</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const paginationBtn = (active) => ({
  cursor: active ? 'pointer' : 'not-allowed'
});

export default LeadManagement;